import React from 'react';
import { motion } from 'framer-motion';
import { Send } from 'lucide-react';
export function LeadForm() {
  return <motion.div initial={{
    opacity: 0,
    x: 50
  }} animate={{
    opacity: 1,
    x: 0
  }} transition={{
    duration: 0.8,
    delay: 0.2
  }} className="w-full max-w-md glass-card p-6 sm:p-8 rounded-[2rem] sm:rounded-[2.5rem] border-brand-accent/20 shadow-2xl shadow-brand-accent/5" data-id="element-128">
      <div className="mb-6 sm:mb-8" data-id="element-129">
        <h3 className="text-xl sm:text-2xl font-serif font-bold text-white mb-2" data-id="element-130">
          Book Your Discovery Call
        </h3>
        <p className="text-slate-400 text-xs sm:text-sm" data-id="element-131">
          Get a tailored scaling strategy for your business.
        </p>
      </div>

      <form className="space-y-3 sm:space-y-4" onSubmit={e => e.preventDefault()} data-id="element-132">
        <div className="space-y-1.5" data-id="element-133">
          <label className="text-xs font-bold uppercase tracking-widest text-slate-500 ml-1" data-id="element-134">
            Full Name
          </label>
          <input type="text" placeholder="John Doe" className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-white placeholder:text-slate-600 focus:outline-none focus:border-brand-accent/50 transition-colors" data-id="element-135" />
        </div>

        <div className="space-y-1.5" data-id="element-136">
          <label className="text-xs font-bold uppercase tracking-widest text-slate-500 ml-1" data-id="element-137">
            Work Email
          </label>
          <input type="email" placeholder="john@company.com" className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-white placeholder:text-slate-600 focus:outline-none focus:border-brand-accent/50 transition-colors" data-id="element-138" />
        </div>

        <div className="space-y-1.5" data-id="element-139">
          <label className="text-xs font-bold uppercase tracking-widest text-slate-500 ml-1" data-id="element-140">
            Service Interest
          </label>
          <select className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-white focus:outline-none focus:border-brand-accent/50 transition-colors appearance-none cursor-pointer" data-id="element-141">
            <option className="bg-brand-dark" data-id="element-142">Lead Generation</option>
            <option className="bg-brand-dark" data-id="element-143">Cold Outreach</option>
            <option className="bg-brand-dark" data-id="element-144">HRaaS & Staffing</option>
            <option className="bg-brand-dark" data-id="element-145">Digital Marketing</option>
          </select>
        </div>

        <div className="pt-4" data-id="element-146">
          <button className="w-full bg-brand-accent text-brand-dark font-black py-4 rounded-xl flex items-center justify-center gap-2 hover:bg-white transition-all transform hover:scale-[1.02] active:scale-[0.98]" data-id="element-147">
            Submit Request
            <Send className="w-4 h-4" data-id="element-148" />
          </button>
        </div>

        <p className="text-[10px] text-center text-slate-500 mt-4 uppercase tracking-tighter" data-id="element-149">
          By submitting, you agree to our privacy policy.
        </p>
      </form>
    </motion.div>;
}